import {gql, useMutation, MutationHookOptions} from '@apollo/client';
import type {
  UpdateFsmStateMutation,
  UpdateFsmStateMutationVariables,
} from '../types/graphql';

/**
 * Change the FSM state for the given client.
 */
export const UPDATE_FSM_STATE = gql`
  mutation UpdateFsmState($accountId: ID!, $newState: String!) {
    updateFsmState(clientAccountId: $accountId, newState: $newState)
  }
`;

/**
 * Hook for updating client FSM state.
 */
export const useUpdateFsmState = (
  opts?: MutationHookOptions<
    UpdateFsmStateMutation,
    UpdateFsmStateMutationVariables
  >,
) =>
  useMutation<UpdateFsmStateMutation, UpdateFsmStateMutationVariables>(
    UPDATE_FSM_STATE,
    opts,
  );
